import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'
import PageHero from '@/components/PageHero'
import CtaBand from '@/components/CtaBand'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { guides, guidesHub } from '@/content/guides'
import { cardImageOf, heroImageOf } from '@/content/applyImages'

export default function GuidesHubPage() {
  return (
    <SiteLayout>
      <Seo
        title={guidesHub.seoTitle}
        description={guidesHub.seoDescription}
        path={guidesHub.path}
        image={heroImageOf(guidesHub)}
      />
      <PageHero
        title={guidesHub.title}
        description={guidesHub.description}
        image={heroImageOf(guidesHub)}
        eyebrow="Resources"
      />
      <section className="py-16 bg-background">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {guides.map((guide) => (
              <Link key={guide.slug} to={guide.path} className="block group">
                <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="h-40 overflow-hidden">
                    <img
                      src={cardImageOf(guide)}
                      alt={guide.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <CardHeader>
                    <CardTitle>{guide.title}</CardTitle>
                    <CardDescription className="line-clamp-3">{guide.summary}</CardDescription>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
          <p className="text-center text-muted-foreground mt-12">
            New to Tillio?{' '}
            <Link to="/how-it-works" className="text-primary hover:underline">
              See how it works
            </Link>{' '}
            or{' '}
            <Link to="/compare/stripe" className="text-primary hover:underline">
              compare Tillio with the Stripe Dashboard
            </Link>
            .
          </p>
        </div>
      </section>
      <CtaBand />
    </SiteLayout>
  )
}
